/**
 * WingmanLogo.js
 * Reusable Wingman brand logo component.
 * The logo uses gradient fills from #1A3FCC to #0D2066.
 * When rendered on a dark/gradient background, use fill="white" to override.
 */
import React from 'react';

function WingmanLogo({ size = 24, fill = null, style = {} }) {
  // When fill is provided, override the gradient with a solid fill
  const useSolidFill = !!fill;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 772 509"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M348 243.5L102 305V317.5L100 326L97.5 334.5L208.5 320.5L288 310.5L393.5 295.5L511.5 277L527.5 273L544 267.5L562.5 258.5L582 246.5L599 234L613 221L628 204L639.5 186.5L647 170.5L650 161L588 179.5L458 214.5L348 243.5Z"
        fill={useSolidFill ? fill : 'url(#wm_g1)'}
      />
      <path
        d="M212.5 344.5L89.5 358L88 364L85 370.5L77 388L59 421.5L34 461L0 508.5L45 479.5L73.5 461L103 441L123 426H133.5L146.5 425L164.5 423.5L183 421.5L206.5 418.5L236.5 414.5L266.5 410L295 404.5L326 397L347.5 391L369 383.5L388.5 375.5L412.5 364L430.5 353L441 345L454 334L466 320.5L475.5 307.5L430.5 315.5L334 328.5L212.5 344.5Z"
        fill={useSolidFill ? fill : 'url(#wm_g2)'}
      />
      <path
        d="M276.5 160L79.5 203L88.5 214.5L95.5 227.5L101 246.5L103 265.5V280.5L240 243.5L416 197L653.5 137.5L677 127.5L706.5 108.5L730 86.5L748 63.5C746.833 65.5 758 47 758 47L772 10.5V0L728.5 22.5L669 47L559 84L432 121L276.5 160Z"
        fill={useSolidFill ? fill : 'url(#wm_g3)'}
      />
      {!useSolidFill && (
        <defs>
          <linearGradient id="wm_g1" x1="650" y1="247.75" x2="97.5" y2="247.75" gradientUnits="userSpaceOnUse">
            <stop offset="0.158654" stopColor="#1A3FCC" />
            <stop offset="0.538462" stopColor="#0D2066" />
          </linearGradient>
          <linearGradient id="wm_g2" x1="475.5" y1="408" x2="0" y2="408" gradientUnits="userSpaceOnUse">
            <stop offset="0.158654" stopColor="#1A3FCC" />
            <stop offset="0.423077" stopColor="#0D2066" />
          </linearGradient>
          <linearGradient id="wm_g3" x1="772" y1="140.25" x2="79.5" y2="140.25" gradientUnits="userSpaceOnUse">
            <stop offset="0.100962" stopColor="#1A3FCC" />
            <stop offset="0.475962" stopColor="#0D2066" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}

export default WingmanLogo;
